export const PAID_OUT = 'PAID_OUT';
export const PAID_OUT_WITH_BONUS = 'PAID_OUT_WITH_BONUS';
export const IN_PROGRESS = 'IN_PROGRESS';
export const FAILED = 'FAILED';
export const HIDDEN = 'HIDDEN';
